import { safeApiRequest } from './apiClient';

const BASE = '/api/review-app';

export const fetchReviewContext = () =>
  safeApiRequest(`${BASE}/context`, { method: 'GET' });

export const fetchReviewCustomers = () =>
  safeApiRequest(`${BASE}/customers`, { method: 'GET' });

export const createReviewServiceRecord = (payload) =>
  safeApiRequest(`${BASE}/service-records`, {
    method: 'POST',
    body: payload,
  });
